import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Briefs = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        d="M1.8125 5.76019C1.8125 5.40871 2.16559 5.16693 2.49329 5.29402L7.5842 7.26838C7.77661 7.343 7.90341 7.52818 7.90341 7.73455V14.5894C7.90341 14.9409 7.55032 15.1827 7.22262 15.0556L2.13171 13.0812C1.9393 13.0066 1.8125 12.8214 1.8125 12.6151V5.76019Z"
        fill="white"
        stroke={color}
      />
      <path
        d="M4.95459 2.76019C4.95459 2.40871 5.30768 2.16693 5.63538 2.29402L10.7263 4.26838C10.9187 4.343 11.0455 4.52818 11.0455 4.73455V11.5894C11.0455 11.9409 10.6924 12.1827 10.3647 12.0556L5.2738 10.0812C5.08139 10.0066 4.95459 9.82143 4.95459 9.61506V2.76019Z"
        fill="white"
        stroke={color}
      />
      <path
        d="M7.90918 5.76019C7.90918 5.40871 8.26227 5.16693 8.58997 5.29402L13.6809 7.26838C13.8733 7.343 14.0001 7.52818 14.0001 7.73455V14.5894C14.0001 14.9409 13.647 15.1827 13.3193 15.0556L8.22839 13.0812C8.03598 13.0066 7.90918 12.8214 7.90918 12.6151V5.76019Z"
        fill="white"
        stroke={color}
      />
      <path d="M10.8594 8.0625L12.4062 8.64062" stroke={color} strokeLinecap="round" />
      <path d="M10.772 10.0366L12.3188 10.6147" stroke={color} strokeLinecap="round" />
      <path d="M10.772 11.9717L12.3188 12.5498" stroke={color} strokeLinecap="round" />
      <path d="M4.74072 11.8779L6.2876 12.4561" stroke={color} strokeLinecap="round" />
      <path
        d="M9.97702 7.50954C9.97702 7.78568 9.75316 8.00954 9.47702 8.00954C9.20087 8.00954 8.97702 7.78568 8.97702 7.50954C8.97702 7.2334 9.20087 7.00954 9.47702 7.00954C9.75316 7.00954 9.97702 7.2334 9.97702 7.50954Z"
        fill={color}
      />
      <path
        d="M9.97702 9.5757C9.97702 9.85184 9.75316 10.0757 9.47702 10.0757C9.20087 10.0757 8.97702 9.85184 8.97702 9.5757C8.97702 9.29956 9.20087 9.0757 9.47702 9.0757C9.75316 9.0757 9.97702 9.29956 9.97702 9.5757Z"
        fill={color}
      />
      <path
        d="M7.03952 8.44045C7.03952 8.71659 6.81566 8.94045 6.53952 8.94045C6.26337 8.94045 6.03952 8.71659 6.03952 8.44045C6.03952 8.1643 6.26337 7.94045 6.53952 7.94045C6.81566 7.94045 7.03952 8.1643 7.03952 8.44045Z"
        fill={color}
      />
      <path
        d="M7.03952 6.50954C7.03952 6.78568 6.81566 7.00954 6.53952 7.00954C6.26337 7.00954 6.03952 6.78568 6.03952 6.50954C6.03952 6.2334 6.26337 6.00954 6.53952 6.00954C6.81566 6.00954 7.03952 6.2334 7.03952 6.50954Z"
        fill={color}
      />
      <path
        d="M7.03952 4.57863C7.03952 4.85477 6.81566 5.07863 6.53952 5.07863C6.26337 5.07863 6.03952 4.85477 6.03952 4.57863C6.03952 4.30249 6.26337 4.07863 6.53952 4.07863C6.81566 4.07863 7.03952 4.30249 7.03952 4.57863Z"
        fill={color}
      />
      <path
        d="M9.97702 11.5498C9.97702 11.826 9.75316 12.0498 9.47702 12.0498C9.20087 12.0498 8.97702 11.826 8.97702 11.5498C8.97702 11.2737 9.20087 11.0498 9.47702 11.0498C9.75316 11.0498 9.97702 11.2737 9.97702 11.5498Z"
        fill={color}
      />
      <path
        d="M3.91452 11.3779C3.91452 11.6541 3.69066 11.8779 3.41452 11.8779C3.13837 11.8779 2.91452 11.6541 2.91452 11.3779C2.91452 11.1018 3.13837 10.8779 3.41452 10.8779C3.69066 10.8779 3.91452 11.1018 3.91452 11.3779Z"
        fill={color}
      />
      <path
        d="M3.91452 9.44045C3.91452 9.71659 3.69066 9.94045 3.41452 9.94045C3.13837 9.94045 2.91452 9.71659 2.91452 9.44045C2.91452 9.1643 3.13837 8.94045 3.41452 8.94045C3.69066 8.94045 3.91452 9.1643 3.91452 9.44045Z"
        fill={color}
      />
      <path
        d="M3.91452 7.56252C3.91452 7.83866 3.69066 8.06252 3.41452 8.06252C3.13837 8.06252 2.91452 7.83866 2.91452 7.56252C2.91452 7.28638 3.13837 7.06252 3.41452 7.06252C3.69066 7.06252 3.91452 7.28638 3.91452 7.56252Z"
        fill={color}
      />
    </svg>
  )
})

export default Briefs
